module.exports = __webpack_public_path__ + "img/H000060_flower.7842738a.png";